/**
 * 会社マスタ
 */
import { isBlank } from '@/utilities/typing'
import PaymentStatus from '@/models/enums/payment-status';
import PriceType from '@/models/enums/price-type';

class Company {
    company_id;
    company_code;
    company_name;
    price_type;
    payment_status;
    expired;
    official_name;
    address_1;
    address_2;
    phone;
    profit_rate_safe;
    profit_rate_danger;
    settlement_month;

    constructor(properties) {
        if (isBlank(properties)) {
            properties = {};
        }

        this.company_id = properties.company_id;
        this.company_code = properties.company_code;
        this.company_name = properties.company_name;
        this.price_type = properties.price_type;
        this.payment_status = properties.payment_status;
        this.expired = properties.expired;
        this.official_name = properties.official_name;
        this.address_1 = properties.address_1;
        this.address_2 = properties.address_2;
        this.phone = properties.phone;
        this.profit_rate_safe = properties.profit_rate_safe;
        this.profit_rate_danger = properties.profit_rate_danger;
        this.settlement_month = properties.settlement_month;
    }

    get payment_status_display() {
        return PaymentStatus.get(this.payment_status);
    }

    get price_type_display() {
        return PriceType.get(this.price_type);
    }

    get phone_e164() {
        const digits = this.phone.replace(/[\D]/g, '');
        return '+81' + digits.substring(1);
    }

    get expiring_alert() {
        if (this.payment_status === PaymentStatus.CONTINUOUS || this.payment_status === PaymentStatus.FREE) {
            return null;
        }

        // 期限まで７日以内（＝期限の７日前が今日より前）なら
        var expired = new Date(this.expired);
        expired.setDate(expired.getDate() - 7);
        var today = new Date();

        if (expired > today) {
            return null;
        }

        if (this.payment_status === PaymentStatus.TRIAL) {
            return '無料トライアルがまもなく終了します。継続利用する場合は「お支払い」ページよりクレジットカードを登録してください';
        }

        return '契約期間がまもなく終了します。継続利用する場合は「お支払い」ページよりクレジットカードを登録してください';
    }
}

export default Company;
